import { createContext, useContext } from "react";

export const AuthContext = createContext({
	login: () => {},
	logout: () => {},
	token: undefined,
	user: undefined,
	permission: undefined,
	isLoading: false,
	setUser: () => {},
});

export const useAuthContext = () => useContext(AuthContext);
